// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { useAuth } from "../../Utility/AuthProvider";
// import { useUnitDetails } from "./UnitDetailsContext";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import CircularInitial from "../UpcomingRent/CircularInitial";
// import PhoneIcon from "../../assets/DashboardIcons/Phone.svg";
// import CustomImage, { IMAGE_TYPES } from "../../Utility/CustomImage";
// import VacantBtn from "../../components/Buttons/VacantBtn";
// import RentedBtn from "../../components/Buttons/RentedBtn";
// import { PiBuildingsLight } from "react-icons/pi";
// import WhatsAppComponent from "../Reports/components/WhatsappComponent";
// import { extractDatePart, calculateDueDate } from "../../Utility/Utils";
// import Facility from "./Facility";
// import CustomModalEditUnit from "../Modals/CustomModalEditUnit";
// import CustomButton from "../Buttons/CustomButton";
// import MonthIcons from "../../Utility/MonthIcons";
// import TenantDetailsModal from "../Modals/TenantDetailsModal";
// // import EditAgreementModal from "../../EditAgreementModal"; // Import the new modal
// import EditAgreementModal from "../Agreements/EditAgreementModal";
// import { useTenantContext } from "../Tenants/TenantContext";

// import { IoIosBed, IoIosWifi, IoIosSnow } from "react-icons/io";
// import { BiCctv } from "react-icons/bi";
// import { PiTelevisionDuotone } from "react-icons/pi";
// import { CiParking1 } from "react-icons/ci";
// import { LuRefrigerator } from "react-icons/lu";
// import { MdLocalLaundryService } from "react-icons/md";
// import { MdOutlineSecurity } from "react-icons/md";
// import { CiPower } from "react-icons/ci";
// import { PiFan } from "react-icons/pi";
// import { FaHandsHelping } from "react-icons/fa";

// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";

// function UnitDetails() {
//   const { route } = useParams();
//   const { jwt } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const {
//     unitDetails,
//     loading: unitLoading,
//     error,
//     fetchUnitDetails,
//     updateUnitDetails,
//     forceRefreshUnitDetails,
//     clearUnitFromCache,
//   } = useUnitDetails();

//   const { unitId } = useParams(); // Use the ID from the URL: /dashboard/my-properties/:unitId
//   // This will be our trigger to force a refresh after adding an agreement.
//   const forceRefresh = location.state?.forceRefresh;
//   // Get tenant context functions
//   const { fetchTenantById, clearAllTenantCache, forceRefreshTenant } =
//     useTenantContext();

//   const [tenantData, setTenantData] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [buildings, setBuildings] = useState([]);
//   const [loadingBuildings, setLoadingBuildings] = useState(true);
//   const [errorBuildings, setErrorBuildings] = useState(null);
//   const [tenantDetailsModal, setTenantDetailsModal] = useState(false);
//   const [transactionData, setTransactionData] = useState(null);
//   const [paymentsData, setPaymentsData] = useState(null);
//   const [refreshUnit, setRefreshUnit] = useState(false);
//   const [updateError, setUpdateError] = useState(null);
//   const [editAgreementModal, setEditAgreementModal] = useState(false);
//   const [toastMessage, setToastMessage] = useState(null);

//   // New state for multiple tenants
//   const [agreementTenants, setAgreementTenants] = useState([]);
//   const [loadingTenants, setLoadingTenants] = useState(false);
//   const [selectedTenantForModal, setSelectedTenantForModal] = useState(null);
//   const [showAllTenants, setShowAllTenants] = useState(false);

//   const unitFromState = location.state?.unit;
//   const entity_id = unitFromState?.entity_id;
//   const unit_id = location.state?.updateData?.unit_id;
//   const entity_id_2 = location.state?.entity_id;
//   const needsUpdate = location.state?.needsUpdate;
//   const updateData = location.state?.updateData;

//   console.log("🔍 Entity ID on Unit Details --", entity_id);
//   console.log("📦 Full location state --", location.state);

//   // Modified useEffect to use the destructured entity_id
//   // useEffect(() => {
//   //   if (unit_id) {
//   //     console.log("🔄 Fetching unit details for unit_id:", unit_id);
//   //     fetchUnitDetails(unit_id, true);
//   //   } else {
//   //     console.log("⚠️ No entity_id available for fetching unit details");
//   //   }
//   // }, [unit_id, fetchUnitDetails, jwt]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const paymentDataResponse = await APICall(
//           "POST",
//           paths.payments.fetch,
//           undefined,
//           undefined,
//           jwt
//         );
//         setPaymentsData(paymentDataResponse.response.payments);

//         const buildingsResponse = await APICall(
//           "GET",
//           paths.building.fetch,
//           undefined,
//           undefined,
//           jwt
//         );
//         setBuildings(buildingsResponse.response);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoadingBuildings(false);
//       }
//     };

//     fetchData();
//   }, [jwt]);

//   // useEffect(() => {
//   //   if (entity_id) {
//   //     console.log("🔄 Fetching unit details for entity_id:", entity_id);
//   //     fetchUnitDetails(entity_id);
//   //   } else {
//   //     console.log(
//   //       "😎 No entity_id available for fetching unit details from unit details"
//   //     );
//   //   }
//   // }, [entity_id, fetchUnitDetails, jwt, refreshUnit]);

//   // --- REPLACE ALL OTHER `fetchUnitDetails` useEffects WITH THIS ONE ---
//   useEffect(() => {
//     // We need a valid unitId from the URL to proceed.
//     if (unitId) {
//       console.log(
//         `🔄 UnitDetails page mounted or unitId/forceRefresh changed. Fetching for: ${unitId}, Force Refresh: ${!!forceRefresh}`
//       );
//       // The second argument `forceRefresh` will be true if we navigated with that state.
//       // This will bypass the cache in the context.
//       fetchUnitDetails(unitId, forceRefresh);

//       // Optional: After a forced refresh, we can clean up the location state
//       // so that a normal browser refresh doesn't trigger it again.
//       if (forceRefresh) {
//         navigate(location.pathname, { replace: true }); // Removes the state from history
//       }
//     } else {
//       console.error("⚠️ No unitId found in URL parameters.");
//     }
//   }, [unitId, forceRefresh, fetchUnitDetails, navigate]); // This effect runs when the component mounts, or if the unitId/forceRefresh changes.

//   // New useEffect to fetch all tenants for the agreement
//   useEffect(() => {
//     const fetchAgreementTenants = async () => {
//       if (!unitDetails?.agreement?.tenant_id || !fetchTenantById) {
//         setAgreementTenants([]);
//         return;
//       }

//       setLoadingTenants(true);
//       try {
//         const tenantIds = unitDetails.agreement.tenant_id;
//         console.log("🧑‍🤝‍🧑 Fetching tenants for IDs:", tenantIds);

//         if (Array.isArray(tenantIds)) {
//           // If tenant_id is an array, fetch all tenants
//           const tenantPromises = tenantIds.map((id) => fetchTenantById(id));
//           const tenants = await Promise.all(tenantPromises);
//           const validTenants = tenants.filter((tenant) => tenant !== null);
//           setAgreementTenants(validTenants);
//           console.log("✅ Fetched multiple tenants:", validTenants);
//         } else {
//           // If tenant_id is a single ID, fetch that tenant
//           const tenant = await fetchTenantById(tenantIds);
//           if (tenant) {
//             setAgreementTenants([tenant]);
//             console.log("✅ Fetched single tenant:", tenant);
//           } else {
//             setAgreementTenants([]);
//           }
//         }
//       } catch (error) {
//         console.error("❌ Error fetching agreement tenants:", error);
//         setAgreementTenants([]);
//       } finally {
//         setLoadingTenants(false);
//       }
//     };

//     fetchAgreementTenants();
//   }, [unitDetails?.agreement?.tenant_id, fetchTenantById]);

//   const handleUpdateSuccess = async (updatedDetails) => {
//     await updateUnitDetails(updatedDetails, jwt);
//     setIsModalOpen(false);
//     setRefreshUnit(!refreshUnit);
//   };

//   // Handle agreement updates
//   const handleAgreementUpdate = async (updatedAgreement) => {
//     try {
//       console.log("🔄 handleAgreementUpdate called with:", updatedAgreement);

//       // Force refresh the unit details to get updated data
//       const currentEntityId = entity_id || unit_id || entity_id_2;
//       console.log("🆔 Current entity ID for refresh:", currentEntityId);

//       if (currentEntityId) {
//         // Clear both unit and tenant caches
//         clearUnitFromCache(currentEntityId);
//         clearAllTenantCache();

//         // await fetchUnitDetails(currentEntityId, true);
//         // await forceRefreshUnitDetails(currentEntityId);
//         // Force refresh with a slight delay to ensure API has processed the update
//         setTimeout(async () => {
//           try {
//             await fetchUnitDetails(currentEntityId, true);
//             console.log("✅ Unit details refreshed successfully");
//           } catch (refreshError) {
//             console.error("❌ Error refreshing unit details:", refreshError);
//           }
//         }, 500);
//       }

//       // Show success message
//       setToastMessage({
//         type: "success",
//         message: updatedAgreement
//           ? "Agreement updated successfully!"
//           : "Agreement terminated successfully!",
//       });

//       // Clear toast after 3 seconds
//       setTimeout(() => setToastMessage(null), 3000);
//       if (!updatedAgreement) {
//         setTimeout(() => {
//           window.location.reload();
//         }, 1500); // Small delay to show the success message
//       }
//     } catch (error) {
//       console.error("❌ Error handling agreement update:", error);
//       setToastMessage({
//         type: "error",
//         message: "Error updating agreement. Please try again.",
//       });
//       setTimeout(() => setToastMessage(null), 3000);
//     }
//   };

//   // Handle unit update logic (existing code)
//   useEffect(() => {
//     const handleUnitUpdate = async () => {
//       console.log("🚀 Starting unit update process...");
//       console.log("📋 Update Data:", {
//         needsUpdate,
//         updateData,
//         unitId: unitFromState?.entity_id,
//       });

//       try {
//         if (!needsUpdate || !updateData || !entity_id_2) {
//           console.log("⛔ Update conditions not met, skipping update");
//           return;
//         }

//         // Clear both caches after successful unit update
//         clearUnitFromCache(entity_id_2);
//         clearAllTenantCache();

//         console.log("🏠 Updating unit with data:", {
//           agreement_id: updateData.agreement_id,
//           rent: updateData.rent,
//           unit_id: updateData.unit_id,
//           occupancy_status: updateData.occupancy_status,
//           tenant_name: updateData.tenant_name,
//         });

//         const unitUpdateResponse = await APICall(
//           "PUT",
//           paths.unit.update,
//           {
//             agreement_id: updateData.agreement_id,
//             rent: updateData.rent,
//             unit_id: updateData.unit_id,
//             occupancy_status: updateData.occupancy_status,
//             tenant_name: updateData.tenant_name,
//           },
//           undefined,
//           jwt
//         );

//         console.log("✅ Unit update successful:", unitUpdateResponse);

//         let shouldUpdateCountTenantCount = false;
//         let countToUpdate = 0;

//         if (updateData.isUpdate) {
//           console.log("🔄 Calculating tenant count for update...");
//           const newTenantCount = updateData.tenantCount;
//           const oldTenantCount = updateData.originalAgreementTenantCount;

//           console.log("👥 Tenant counts:", {
//             new: newTenantCount,
//             old: oldTenantCount,
//           });

//           if (newTenantCount !== oldTenantCount) {
//             shouldUpdateCountTenantCount = true;
//             countToUpdate = newTenantCount - oldTenantCount;
//             console.log("📊 Tenant count needs update. Delta:", countToUpdate);
//           }
//         }

//         if (!updateData.isUpdate || shouldUpdateCountTenantCount) {
//           console.log("🏢 Updating building count...");
//           const buildingUpdateResponse = await APICall(
//             "PUT",
//             paths.building.updateCount,
//             {
//               building_id: updateData.building_id,
//               tenant_count: updateData.isUpdate
//                 ? countToUpdate
//                 : updateData.tenantCount,
//             },
//             undefined,
//             jwt
//           );
//           console.log(
//             "✅ Building count update successful:",
//             buildingUpdateResponse
//           );
//         }

//         console.log("🔄 Refreshing unit details with unit_id:", entity_id_2);
//         await fetchUnitDetails(entity_id_2, jwt);
//         console.log("✨ Unit details refresh complete");
//       } catch (error) {
//         console.error("❌ Error in unit update process:", error);
//         setUpdateError(
//           error.message || "An error occurred while updating the unit."
//         );
//       }

//       console.log("🏁 Unit update process complete");
//     };

//     handleUnitUpdate();
//   }, [
//     needsUpdate,
//     updateData,
//     jwt,
//     unitFromState?.entity_id,
//     fetchUnitDetails,
//     clearUnitFromCache,
//     clearAllTenantCache,
//   ]);

//   if (updateError) {
//     return <p>Error updating unit: {updateError}</p>;
//   }

//   if (unitLoading || loadingBuildings)
//     return (
//       <div className="flex flex-col justify-center items-center">
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           className="w-20 h-20"
//         />
//         <span className="text-gray-600 mt-2 font-medium">
//           Loading rent data...
//         </span>
//       </div>
//     );

//   if (error) return <p>Error: {error?.message}</p>;

//   if (!unitDetails) return <p>No unit data available 😔</p>;

//   const { agreement, tenant, transactions, unitdata } = unitDetails;
//   const agreementDetails = agreement || {};

//   // Safe data extraction function
//   const getUnitDetail = (path, defaultValue = "") => {
//     if (!unitDetails || !unitDetails.unit) return defaultValue;
//     const parts = path.split(".");
//     let value = unitDetails.unit;
//     for (const part of parts) {
//       if (value == null) return defaultValue;
//       value = value[part];
//     }
//     return value == null ? defaultValue : value;
//   };

//   const amenitiesList = getUnitDetail("amenities", "").split(",");
//   const unitName = getUnitDetail("unit_name", "Unit Name Not Available");
//   const buildingName = getUnitDetail(
//     "building_name",
//     "Building Name Not Available"
//   );
//   const occupancyStatus = getUnitDetail(
//     "occupancy_status",
//     "Status Not Available"
//   );
//   const address = getUnitDetail("address", "Address Not Available");
//   const rent = getUnitDetail("rent", "Rent Not Available");
//   const mediaLocation = getUnitDetail("media.0.location", null);
//   const unitArea = getUnitDetail("unit_area", "Area Not Available");
//   const bhk = getUnitDetail("bhk", "BHK Not Available");
//   const furnishingStatus = getUnitDetail(
//     "furnishing_status",
//     "Furnishing Not Available"
//   );
//   const noOfBalcony = getUnitDetail("no_of_balcony", "Balcony Not Available");
//   const noOfBathrooms = getUnitDetail(
//     "no_of_bathrooms",
//     "Bathroom Not Available"
//   );

//   const getInitials = (name) => {
//     const nameParts = name.split(" ");
//     return nameParts
//       .map((part) => part.charAt(0))
//       .join("")
//       .toUpperCase();
//   };

//   const mapAmenitiesToIcons = (amenity) => {
//     switch (amenity.trim().toLowerCase()) {
//       case "wifi":
//         return { icon: IoIosWifi, name: "WiFi" };
//       case "cctv":
//         return { icon: BiCctv, name: "CCTV" };
//       case "television":
//         return { icon: PiTelevisionDuotone, name: "Television" };
//       case "parking":
//         return { icon: CiParking1, name: "Parking" };
//       case "refrigerator":
//         return { icon: LuRefrigerator, name: "Refrigerator" };
//       case "laundry":
//         return { icon: MdLocalLaundryService, name: "Laundry" };
//       case "security":
//         return { icon: MdOutlineSecurity, name: "Security" };
//       case "inverter":
//         return { icon: CiPower, name: "Inverter" };
//       case "bed":
//         return { icon: IoIosBed, name: "Bed" };
//       case "fan":
//         return { icon: PiFan, name: "fan" };
//       case "AC":
//         return { icon: IoIosSnow, name: "AC" };
//       default:
//         return { icon: FaHandsHelping, name: "Friendly" };
//     }
//   };

//   // Helper function to render tenant avatar
//   const renderTenantAvatar = (tenant, size = "h-20 w-20") => {
//     const fullName =
//       `${tenant.first_name || ""} ${tenant.last_name || ""}`.trim();
//     const initials = getInitials(fullName || tenant.entity_id);

//     if (tenant.media?.profile_picture?.location) {
//       return (
//         <CustomImage
//           location={tenant.media.profile_picture.location}
//           jwt={jwt}
//           initials={initials}
//           className={`${size} rounded-full object-cover`}
//         />
//       );
//     } else {
//       return (
//         <div
//           className={`${size} flex items-center justify-center rounded-full bg-gray-200 text-gray-600 font-semibold`}
//         >
//           {initials}
//         </div>
//       );
//     }
//   };

//   // Helper function to render tenant info
//   const renderTenantInfo = (tenant) => {
//     const fullName =
//       `${tenant.first_name || ""} ${tenant.last_name || ""}`.trim();
//     return (
//       <div className="flex flex-col">
//         <p className="font-semibold">{fullName || "Unknown Tenant"}</p>
//         <p className="text-gray-600">{tenant.mobile || "No phone number"}</p>
//       </div>
//     );
//   };

//   console.log("📦 Unit Details Data:", unitDetails);
//   console.log("🧑‍🤝‍🧑 Agreement Tenants:", agreementTenants);

//   return (
//     <div className="text-xs border-2 rounded-2xl p-10">
//       {/* Toast Notification */}
//       {toastMessage && (
//         <div
//           className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 ${
//             toastMessage.type === "success"
//               ? "bg-green-500 text-white"
//               : "bg-red-500 text-white"
//           }`}
//         >
//           {toastMessage.message}
//         </div>
//       )}

//       {/* row1 */}
//       <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//         {/* Container for Unit Details and Agreement Details */}
//         <div className="flex flex-col justify-between rounded-lg p-4">
//           {/* Unit Details Container */}
//           <div className="flex flex-col mb-4">
//             <div className="flex items-center justify-between mb-4">
//               <p className="text-xl font-semibold">Unit</p>
//               {agreement ? <WhatsAppComponent selectedTenant={tenant} /> : null}
//             </div>
//             <div className="bg-white rounded-lg p-5 flex flex-col md:flex-row gap-4">
//               <div className="flex-1">
//                 <div className="flex justify-between items-center mb-4">
//                   <div className="flex items-center">
//                     <p className="text-lg pr-4">{unitName}</p>
//                     {occupancyStatus === "vacant" ? (
//                       <VacantBtn>Vacant</VacantBtn>
//                     ) : (
//                       <RentedBtn>Rented</RentedBtn>
//                     )}
//                   </div>
//                 </div>
//                 <p>{buildingName}</p>
//                 <p>{address}</p>
//                 {occupancyStatus != "vacant" && (
//                   <>
//                     <p className="font-bold mt-4">Rent</p>
//                     <p>{rent}</p>
//                   </>
//                 )}
//               </div>
//               <div className="rounded-lg flex justify-center items-center">
//                 {mediaLocation ? (
//                   <CustomImage
//                     location={mediaLocation}
//                     jwt={jwt}
//                     initials={getInitials(unitDetails.unit.entity_id)}
//                     className="w-full h-full object-cover"
//                   />
//                 ) : (
//                   <div
//                     className="text-white text-xl flex items-center justify-center"
//                     style={{ width: "100px", height: "100px" }}
//                   >
//                     <PiBuildingsLight size={100} color="grey" />
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Agreement Details */}
//           <p className="text-xl font-semibold mb-4">Agreement Details</p>
//           <div className="bg-white rounded-lg border-1 p-10">
//             {agreement ? (
//               <div className="flex flex-col md:flex-row gap-4">
//                 <>
//                   <div className="flex-1">
//                     <p className="flex flex-col">
//                       <strong className="text-gray-500">Monthly Rent</strong>
//                       {agreementDetails.rent[0].rent}
//                     </p>
//                     <p className="flex flex-col">
//                       <strong className="text-gray-500">Due Date</strong>
//                       {calculateDueDate(agreementDetails.due_date)}
//                     </p>
//                     <p className="flex flex-col">
//                       <strong className="text-gray-500">Staying From</strong>
//                       {extractDatePart(agreementDetails.staying_from)}
//                     </p>
//                     <p className="flex flex-col">
//                       <strong className="text-gray-500">
//                         Security Deposit
//                       </strong>
//                       {agreementDetails.security_deposit}
//                     </p>
//                   </div>
//                   <div className="flex-1">
//                     <p className="flex flex-col">
//                       <strong className="text-gray-500">Maintenance</strong>
//                       {agreementDetails.maintenance}
//                     </p>
//                     <p className="flex flex-col">
//                       <strong className="text-gray-500">Tenure</strong>
//                       {agreementDetails.tenure}
//                     </p>
//                     <p className="flex flex-col">
//                       <strong className="text-gray-500">Vacating On</strong>
//                       {extractDatePart(agreementDetails.vacating_on)}
//                     </p>
//                   </div>
//                 </>
//                 <div>
//                   <button
//                     onClick={() => setEditAgreementModal(true)}
//                     className="bg-blue-500 text-white rounded-md p-2 hover:bg-blue-600"
//                   >
//                     Edit
//                   </button>
//                 </div>
//               </div>
//             ) : (
//               <div className="mb-4 p-10 flex flex-col justify-between items-center">
//                 You don't have any tenant right now. Please create your
//                 agreement.
//                 <button
//                   onClick={() => navigate("add-agreement")}
//                   className="bg-black text-white w-40 py-2 rounded-md mt-10 hover:bg-gray-800"
//                 >
//                   Add Agreement
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Container for Transactions and Tenant Details */}
//         <div className="flex flex-col justify-between rounded-lg p-4">
//           {/* Transactions Container */}
//           {transactions?.length > 0 && (
//             <div className="rounded-lg mb-4">
//               <div className="flex justify-between items-center ">
//                 <p className="text-xl font-semibold">Transactions</p>
//                 <p className="cursor-pointer text-blue-500 hover:text-blue-700">
//                   View All
//                 </p>
//               </div>
//               <div className="border bg-white rounded-lg mt-4 p-10">
//                 <div className="border-b border-gray-500 flex justify-center items-center gap-4 p-2">
//                   <p className="font-semibold">Active</p>
//                   <p className="text-gray-500">Archive</p>
//                 </div>
//                 {transactions && transactions.length > 0 && (
//                   <div className="mt-2 flex flex-col gap-5">
//                     {transactions.slice(0, 4).map((transaction, index) => (
//                       <div
//                         key={index}
//                         className="flex justify-between items-center"
//                       >
//                         <div className="flex items-center gap-2">
//                           <MonthIcons month={transaction.month} />
//                           <div>
//                             <p>
//                               {transaction.nature} received for{" "}
//                               {transaction.month}
//                             </p>
//                             <p className="text-gray-500 text-xs">
//                               {transaction.created}
//                             </p>
//                           </div>
//                         </div>
//                         <div className="flex flex-col items-center">
//                           <p className="font-semibold">{transaction.amount}</p>
//                           <p>
//                             {transaction.payment_status === "success" ? (
//                               <CustomButton
//                                 tailwindClasses="bg-green-500 h-4 text-xs flex justify-center items-center text-white px-2 py-1 rounded"
//                                 label="Paid"
//                                 onClick={() => {}}
//                               />
//                             ) : (
//                               <CustomButton
//                                 tailwindClasses="bg-orange-500 text-white px-2 py-1 rounded text-xs"
//                                 label="Pending"
//                                 onClick={() => {}}
//                               />
//                             )}
//                           </p>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* Tenant Details Container */}
//           {/* {unitDetails.tenant && (
//             <div>
//               <p className="text-xl font-semibold mb-4">Tenant Details</p>
//               <div className="rounded-lg bg-white p-10 flex flex-col gap-4">
//                 <div className="flex items-center gap-4">
//                   <>
//                     {unitDetails.tenant.media &&
//                     unitDetails.tenant.media.profile_picture &&
//                     unitDetails.tenant.media.profile_picture.location ? (
//                       <CustomImage
//                         location={
//                           unitDetails.tenant.media.profile_picture.location
//                         }
//                         jwt={jwt}
//                         initials={getInitials(
//                           unitDetails.tenant.first_name +
//                             " " +
//                             unitDetails.tenant.last_name
//                         )}
//                         className="h-20 w-20 rounded-full"
//                       />
//                     ) : (
//                       <div className="h-20 w-20 flex items-center justify-center rounded-full bg-gray-200">
//                         {getInitials(
//                           unitDetails.tenant.first_name +
//                             " " +
//                             unitDetails.tenant.last_name
//                         )}
//                       </div>
//                     )}

//                     <div className="flex flex-col">
//                       <p className="font-semibold">
//                         {unitDetails.tenant.first_name}{" "}
//                         {unitDetails.tenant.last_name}
//                       </p>
//                       <p className="text-gray-600">
//                         {unitDetails.tenant.mobile}
//                       </p>
//                       <div className="mt-2">
//                         <WhatsAppComponent
//                           label={"Send Message"}
//                           selectedTenant={tenant}
//                         />
//                       </div>
//                     </div>
//                   </>
//                 </div>

//                 <div className="flex gap-2">
//                   <button
//                     onClick={() =>
//                       window.open(`tel:${unitDetails.tenant.mobile}`)
//                     }
//                     className="flex-1 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 flex items-center justify-center gap-2"
//                   >
//                     📞 Call
//                   </button>

//                   {tenant && (
//                     <CustomButton
//                       tailwindClasses="flex-1 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//                       label="See Details"
//                       onClick={() => setTenantDetailsModal(true)}
//                     />
//                   )}
//                 </div>

//                 {tenantDetailsModal && unitDetails && (
//                   <TenantDetailsModal
//                     isOpen={tenantDetailsModal}
//                     onClose={() => setTenantDetailsModal(false)}
//                     unitDetails={unitDetails}
//                   />
//                 )}
//               </div>
//             </div>
//           )} */}

//           {agreementTenants.length > 0 && (
//             <div>
//               <p className="text-xl font-semibold mb-4">Tenant Details</p>
//               <div className="rounded-lg bg-white p-10 flex flex-col gap-4">
//                 {loadingTenants ? (
//                   <div className="flex items-center justify-center p-4">
//                     <p>Loading tenants...</p>
//                   </div>
//                 ) : (
//                   <>
//                     {/* Primary Tenant Display */}
//                     <div className="flex items-center gap-4">
//                       {renderTenantAvatar(agreementTenants[0])}
//                       <div className="flex-1">
//                         {renderTenantInfo(agreementTenants[0])}

//                         {/* Show additional tenants indicator */}
//                         {agreementTenants.length > 1 && (
//                           <button
//                             onClick={() => setShowAllTenants(!showAllTenants)}
//                             className="text-blue-500 hover:text-blue-700 text-sm mt-2"
//                           >
//                             {showAllTenants
//                               ? "Show less"
//                               : `+ ${agreementTenants.length - 1} more`}
//                           </button>
//                         )}

//                         <div className="mt-2">
//                           <WhatsAppComponent
//                             label={"Send Message"}
//                             selectedTenant={agreementTenants[0]}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     {/* Additional Tenants (shown when expanded) */}
//                     {showAllTenants && agreementTenants.length > 1 && (
//                       <div className="border-t pt-4">
//                         <p className="text-sm font-semibold text-gray-600 mb-3">
//                           Other Tenants ({agreementTenants.length - 1})
//                         </p>
//                         <div className="space-y-3">
//                           {agreementTenants.slice(1).map((tenant, index) => (
//                             <div
//                               key={tenant.entity_id || index}
//                               className="flex items-center gap-3 p-2 border rounded-lg"
//                             >
//                               {renderTenantAvatar(tenant, "h-12 w-12")}
//                               <div className="flex-1">
//                                 {renderTenantInfo(tenant)}
//                               </div>
//                               <div className="flex gap-2">
//                                 <button
//                                   onClick={() =>
//                                     window.open(`tel:${tenant.mobile}`)
//                                   }
//                                   className="text-green-600 hover:text-green-800 text-sm"
//                                 >
//                                   📞
//                                 </button>
//                                 <button
//                                   onClick={() =>
//                                     setSelectedTenantForModal(tenant)
//                                   }
//                                   className="text-blue-600 hover:text-blue-800 text-sm"
//                                 >
//                                   Details
//                                 </button>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* Action Buttons */}
//                     <div className="flex gap-2 mt-4">
//                       <button
//                         onClick={() =>
//                           window.open(`tel:${agreementTenants[0].mobile}`)
//                         }
//                         className="flex-1 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 flex items-center justify-center gap-2"
//                       >
//                         📞 Call
//                       </button>

//                       <CustomButton
//                         tailwindClasses="flex-1 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//                         label="See Details"
//                         onClick={() =>
//                           setSelectedTenantForModal(agreementTenants[0])
//                         }
//                       />
//                     </div>
//                   </>
//                 )}

//                 {/* Tenant Details Modal */}
//                 {selectedTenantForModal && (
//                   <TenantDetailsModal
//                     isOpen={!!selectedTenantForModal}
//                     onClose={() => setSelectedTenantForModal(null)}
//                     unitDetails={unitDetails}
//                     selectedTenant={selectedTenantForModal}
//                     allAgreementTenants={agreementTenants}
//                     jwt={jwt}
//                   />
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Unit Details Section */}
//       <p className="text-xl font-semibold pl-8 pt-4 pb-4">Unit Details</p>
//       <div className="bg-white rounded-lg shadow-md p-10">
//         <div className="flex justify-between">
//           <div className="w-1/2 flex flex-col gap-4">
//             {/* First row - Unit info */}
//             <div className="flex flex-col">
//               <p className="font-medium text-lg">{unitName}</p>
//               <p className="text-gray-600">{address}</p>
//             </div>

//             {/* Second row - Main specs */}
//             <div className="flex justify-between items-center">
//               <div className="flex flex-col">
//                 <p className="text-sm text-gray-500">Flat Area</p>
//                 <p className="font-medium">{unitArea}</p>
//               </div>
//               <div className="flex flex-col">
//                 <p className="text-sm text-gray-500">BHK</p>
//                 <p className="font-medium">{bhk}</p>
//               </div>
//               <div className="flex flex-col">
//                 <p className="text-sm text-gray-500">Furnishing</p>
//                 <p className="font-medium">{furnishingStatus}</p>
//               </div>
//             </div>

//             {/* Third row - Additional specs */}
//             <div className="flex">
//               <div className="flex flex-col flex-1">
//                 <p className="text-sm text-gray-500">Balcony</p>
//                 <p className="font-medium">{noOfBalcony}</p>
//               </div>
//               <div className="flex flex-col flex-1">
//                 <p className="text-sm text-gray-500">Bathroom</p>
//                 <p className="font-medium">{noOfBathrooms}</p>
//               </div>
//               <div className="flex-1"></div>
//             </div>
//           </div>
//           <div>
//             <CustomButton
//               tailwindClasses="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//               label="Edit"
//               onClick={() => setIsModalOpen(true)}
//             />
//           </div>
//         </div>

//         {/* Amenities */}
//         <div className="">
//           {amenitiesList.length > 0 && amenitiesList[0].trim() !== "" && (
//             <>
//               <div className="flex flex-wrap gap-4 p-2 rounded-md mt-4">
//                 {amenitiesList.map((amenity, index) => {
//                   const { icon, name } = mapAmenitiesToIcons(amenity);
//                   return <Facility key={index} name={name} icon={icon} />;
//                 })}
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       {/* Modal for editing unit */}
//       {isModalOpen && (
//         <CustomModalEditUnit
//           isOpen={isModalOpen}
//           onClose={() => setIsModalOpen(false)}
//           unitDetails={unitDetails}
//           buildings={buildings}
//           onUpdate={handleUpdateSuccess}
//         />
//       )}

//       {/* Edit Agreement Modal */}
//       {editAgreementModal && agreement && (
//         <EditAgreementModal
//           key={agreement.entity_id + agreement.updated_at} // Force re-render when agreement changes
//           isOpen={editAgreementModal}
//           onClose={() => setEditAgreementModal(false)}
//           agreementData={agreementDetails}
//           onSave={handleAgreementUpdate}
//           jwt={jwt}
//         />
//       )}
//     </div>
//   );
// }

// export default UnitDetails;

// UnitDetails.jsx

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Utility/AuthProvider";
import { useUnitDetails } from "./UnitDetailsContext";
import APICall from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import { useTenantContext } from "../Tenants/TenantContext";
import { extractDatePart, calculateDueDate } from "../../Utility/Utils";

// Import all your components and assets
import CircularInitial from "../UpcomingRent/CircularInitial";
import CustomImage from "../../Utility/CustomImage";
import VacantBtn from "../../components/Buttons/VacantBtn";
import RentedBtn from "../../components/Buttons/RentedBtn";
import WhatsAppComponent from "../Reports/components/WhatsappComponent";
import Facility from "./Facility";
import CustomModalEditUnit from "../Modals/CustomModalEditUnit";
import CustomButton from "../Buttons/CustomButton";
import MonthIcons from "../../Utility/MonthIcons";
import TenantDetailsModal from "../Modals/TenantDetailsModal";
import EditAgreementModal from "../Agreements/EditAgreementModal";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/animations/loader.json";

// Import all your icons
import { PiBuildingsLight, PiTelevisionDuotone, PiFan } from "react-icons/pi";
import { IoIosBed, IoIosWifi, IoIosSnow } from "react-icons/io";
import { BiCctv } from "react-icons/bi";
import { CiParking1, CiPower } from "react-icons/ci";
import { LuRefrigerator } from "react-icons/lu";
import { MdLocalLaundryService, MdOutlineSecurity } from "react-icons/md";
import { FaHandsHelping } from "react-icons/fa";

function UnitDetails() {
  // --- REFACTORED: Use `useParams` as the SINGLE SOURCE OF TRUTH for the ID ---
  const { unitId } = useParams();
  const { jwt } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    unitDetails,
    loading: unitLoading,
    error,
    fetchUnitDetails,
    updateUnitDetails, // We might not need this here, but keep for now
    clearUnitFromCache,
  } = useUnitDetails();

  // --- REFACTORED: Only need `clearAllTenantCache` from this context now ---
  const { clearAllTenantCache } = useTenantContext();

  // --- STATE MANAGEMENT ---
  const [agreementTenants, setAgreementTenants] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [buildings, setBuildings] = useState([]);
  const [loadingBuildings, setLoadingBuildings] = useState(true);
  const [selectedTenantForModal, setSelectedTenantForModal] = useState(null);
  const [editAgreementModal, setEditAgreementModal] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [showAllTenants, setShowAllTenants] = useState(false);

  // --- DATA FETCHING & STATE SYNC ---

  // Effect 1: Fetch the main unit details when the component mounts or the ID changes.
  useEffect(() => {
    const forceRefresh = location.state?.forceRefresh;
    if (unitId) {
      console.log(
        `🔄 UnitDetails: Fetching data for unitId: ${unitId}, Force Refresh: ${!!forceRefresh}`
      );
      fetchUnitDetails(unitId, forceRefresh);

      // Clean up the location state after a forced refresh so it doesn't trigger again
      if (forceRefresh) {
        navigate(location.pathname, { replace: true });
      }
    } else {
      console.error("⚠️ UnitDetails: No unitId found in URL parameters.");
    }
  }, [unitId, location.state, fetchUnitDetails, navigate]);

  // Effect 2: Populate tenants DIRECTLY from the `unitDetails` response. No separate fetch needed.
  useEffect(() => {
    if (unitDetails?.tenant) {
      // The API can return a single object or an array. We always want an array.
      const tenants = Array.isArray(unitDetails.tenant)
        ? unitDetails.tenant
        : [unitDetails.tenant];
      setAgreementTenants(tenants);
      console.log(
        "✅ Tenants populated directly from main API response:",
        tenants
      );
    } else {
      setAgreementTenants([]); // Ensure tenants are cleared if no agreement exists
    }
  }, [unitDetails]); // This runs whenever the main unitDetails data changes.

  // Effect 3: Fetch auxiliary data like buildings (can run in parallel).
  useEffect(() => {
    const fetchAuxData = async () => {
      setLoadingBuildings(true);
      try {
        const buildingsResponse = await APICall(
          "GET",
          paths.building.fetch,
          undefined,
          undefined,
          jwt
        );
        setBuildings(buildingsResponse.response || []);
      } catch (error) {
        console.error("Error fetching buildings:", error);
      } finally {
        setLoadingBuildings(false);
      }
    };
    if (jwt) {
      fetchAuxData();
    }
  }, [jwt]);

  // --- HANDLER FUNCTIONS ---

  const handleUpdateSuccess = async (updatedDetails) => {
    // After editing unit details, we refresh the data
    if (unitId) {
      await fetchUnitDetails(unitId, true);
    }
    setIsModalOpen(false);
  };

  const handleAgreementUpdate = async (updatedAgreement) => {
    try {
      console.log("🔄 Handling agreement update/termination...");
      if (unitId) {
        // Clear caches to ensure we get fresh data
        clearUnitFromCache(unitId);
        clearAllTenantCache();

        // Force a full refresh of the page's data
        await fetchUnitDetails(unitId, true);
        console.log(
          "✅ Unit details refreshed successfully after agreement update."
        );
      }

      setToastMessage({
        type: "success",
        message: updatedAgreement
          ? "Agreement updated successfully!"
          : "Agreement terminated successfully!",
      });
      setTimeout(() => setToastMessage(null), 3000);

      if (!updatedAgreement) {
        // If terminated
        setTimeout(() => window.location.reload(), 1500); // Reload to reset all states cleanly
      }
    } catch (error) {
      console.error("❌ Error handling agreement update:", error);
      setToastMessage({
        type: "error",
        message: "Error updating agreement. Please try again.",
      });
      setTimeout(() => setToastMessage(null), 3000);
    }
  };

  // --- RENDER LOGIC ---

  if (unitLoading || loadingBuildings) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          className="w-24 h-24"
        />
        <span className="text-gray-600 mt-2 font-medium">
          Loading unit data...
        </span>
      </div>
    );
  }

  if (error)
    return (
      <p className="text-center text-red-500">
        Error: {error?.message || "Could not load unit details."}
      </p>
    );
  if (!unitDetails)
    return (
      <p className="text-center text-gray-500">No unit data available 😔</p>
    );

  const { agreement, transactions, unit } = unitDetails;
  const agreementDetails = agreement || {};

  // --- HELPER FUNCTIONS FOR RENDERING ---
  const getUnitDetail = (path, defaultValue = "") => {
    if (!unit) return defaultValue;
    const parts = path.split(".");
    let value = unit;
    for (const part of parts) {
      if (value == null) return defaultValue;
      value = value[part];
    }
    return value == null ? defaultValue : value;
  };

  const getInitials = (name) => {
    if (!name) return "?";
    const nameParts = name.split(" ");
    return nameParts
      .map((part) => part.charAt(0))
      .join("")
      .toUpperCase();
  };

  const mapAmenitiesToIcons = (amenity) => {
    // This function is perfect, no changes needed.
    switch (amenity.trim().toLowerCase()) {
      case "wifi":
        return { icon: IoIosWifi, name: "WiFi" };
      case "cctv":
        return { icon: BiCctv, name: "CCTV" };
      case "television":
        return { icon: PiTelevisionDuotone, name: "Television" };
      case "parking":
        return { icon: CiParking1, name: "Parking" };
      case "refrigerator":
        return { icon: LuRefrigerator, name: "Refrigerator" };
      case "laundry":
        return { icon: MdLocalLaundryService, name: "Laundry" };
      case "security":
        return { icon: MdOutlineSecurity, name: "Security" };
      case "inverter":
        return { icon: CiPower, name: "Inverter" };
      case "bed":
        return { icon: IoIosBed, name: "Bed" };
      case "fan":
        return { icon: PiFan, name: "fan" };
      case "ac":
        return { icon: IoIosSnow, name: "AC" };
      default:
        return { icon: FaHandsHelping, name: amenity };
    }
  };

  const renderTenantAvatar = (tenant, size = "h-20 w-20") => {
    const fullName =
      `${tenant.first_name || ""} ${tenant.last_name || ""}`.trim();
    const initials = getInitials(fullName || tenant.entity_id);
    if (tenant.media?.profile_picture?.location) {
      return (
        <CustomImage
          location={tenant.media.profile_picture.location}
          jwt={jwt}
          initials={initials}
          className={`${size} rounded-full object-cover`}
        />
      );
    }
    return (
      <div
        className={`${size} flex items-center justify-center rounded-full bg-gray-200 text-gray-600 font-semibold`}
      >
        {initials}
      </div>
    );
  };

  const renderTenantInfo = (tenant) => {
    const fullName =
      `${tenant.first_name || ""} ${tenant.last_name || ""}`.trim();
    return (
      <div className="flex flex-col">
        <p className="font-semibold">{fullName || "Unknown Tenant"}</p>
        <p className="text-gray-600">{tenant.mobile || "No phone number"}</p>
      </div>
    );
  };

  // Destructure unit details for cleaner JSX
  const amenitiesList = getUnitDetail("amenities", "").split(",");
  const unitName = getUnitDetail("unit_name", "N/A");
  const occupancyStatus = getUnitDetail("occupancy_status", "N/A");
  const mediaLocation = getUnitDetail("media.0.location", null);

  console.log("✅ Final data ready for render. Tenants:", agreementTenants);

  // --- JSX STRUCTURE ---
  return (
    <div className="text-xs border-2 rounded-2xl p-10">
      {toastMessage && (
        <div
          className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 ${toastMessage.type === "success" ? "bg-green-500 text-white" : "bg-red-500 text-white"}`}
        >
          {toastMessage.message}
        </div>
      )}

      <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Left Column: Unit & Agreement */}
        <div className="flex flex-col justify-between rounded-lg p-4 space-y-8">
          {/* Unit Details Box */}
          <div>
            <div className="flex items-center justify-between mb-4">
              <p className="text-xl font-semibold">Unit</p>
              {agreement && agreementTenants.length > 0 && (
                <WhatsAppComponent selectedTenant={agreementTenants[0]} />
              )}
            </div>
            <div className="bg-white rounded-lg p-5 flex flex-col md:flex-row gap-4 border">
              <div className="flex-1">
                <div className="flex items-center gap-4 mb-4">
                  <p className="text-lg">{unitName}</p>
                  {occupancyStatus === "vacant" ? (
                    <VacantBtn>Vacant</VacantBtn>
                  ) : (
                    <RentedBtn>Rented</RentedBtn>
                  )}
                </div>
                <p>{getUnitDetail("building_name", "N/A")}</p>
                <p>{getUnitDetail("address", "N/A")}</p>
                {occupancyStatus !== "vacant" && (
                  <>
                    <p className="font-bold mt-4">Rent</p>
                    <p>₹{getUnitDetail("rent", "0")}</p>
                  </>
                )}
              </div>
              <div className="rounded-lg flex justify-center items-center">
                {mediaLocation ? (
                  <CustomImage
                    location={mediaLocation}
                    jwt={jwt}
                    initials={getInitials(unitName)}
                    className="w-24 h-24 object-cover rounded-lg"
                  />
                ) : (
                  <PiBuildingsLight size={100} color="grey" />
                )}
              </div>
            </div>
          </div>

          {/* Agreement Details Box */}
          <div>
            <p className="text-xl font-semibold mb-4">Agreement Details</p>
            <div className="bg-white rounded-lg border p-10">
              {agreement ? (
                <div className="flex flex-col md:flex-row gap-4">
                  <div className="flex-1 space-y-2">
                    <p className="flex flex-col">
                      <strong className="text-gray-500">Monthly Rent</strong>₹
                      {agreementDetails.rent[0]?.rent || "N/A"}
                    </p>
                    <p className="flex flex-col">
                      <strong className="text-gray-500">Due Date</strong>
                      {calculateDueDate(agreementDetails.due_date)}
                    </p>
                    <p className="flex flex-col">
                      <strong className="text-gray-500">Staying From</strong>
                      {extractDatePart(agreementDetails.staying_from)}
                    </p>
                    <p className="flex flex-col">
                      <strong className="text-gray-500">
                        Security Deposit
                      </strong>
                      ₹{agreementDetails.security_deposit || "0"}
                    </p>
                  </div>
                  <div className="flex-1 space-y-2">
                    <p className="flex flex-col">
                      <strong className="text-gray-500">Maintenance</strong>₹
                      {agreementDetails.maintenance || "0"}
                    </p>
                    <p className="flex flex-col">
                      <strong className="text-gray-500">Tenure</strong>
                      {agreementDetails.tenure}
                    </p>
                    <p className="flex flex-col">
                      <strong className="text-gray-500">Vacating On</strong>
                      {extractDatePart(agreementDetails.vacating_on)}
                    </p>
                  </div>
                  <button
                    onClick={() => setEditAgreementModal(true)}
                    className="bg-blue-500 text-white rounded-md px-4 py-2 h-fit hover:bg-blue-600"
                  >
                    Edit
                  </button>
                </div>
              ) : (
                <div className="text-center p-4">
                  <p>You don't have any tenant right now.</p>
                  <button
                    onClick={() => navigate("add-agreement")}
                    className="bg-black text-white w-40 py-2 rounded-md mt-6 hover:bg-gray-800"
                  >
                    Add Agreement
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right Column: Transactions & Tenant */}
        <div className="flex flex-col justify-start rounded-lg p-4 space-y-8">
          {/* Transactions Box */}
          {transactions?.length > 0 && (
            <div className="rounded-lg mb-4">
              <div className="flex justify-between items-center ">
                <p className="text-xl font-semibold">Transactions</p>
                <p className="cursor-pointer text-blue-500 hover:text-blue-700">
                  View All
                </p>
              </div>
              <div className="border bg-white rounded-lg mt-4 p-10">
                <div className="border-b border-gray-500 flex justify-center items-center gap-4 p-2">
                  <p className="font-semibold">Active</p>
                  <p className="text-gray-500">Archive</p>
                </div>
                <div className="mt-2 flex flex-col gap-5">
                  {transactions.slice(0, 4).map((transaction, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center"
                    >
                      <div className="flex items-center gap-2">
                        <MonthIcons month={transaction.month} />
                        <div>
                          <p>
                            {transaction.nature} received for{" "}
                            {transaction.month}
                          </p>
                          <p className="text-gray-500 text-xs">
                            {transaction.created}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col items-center">
                        <p className="font-semibold">{transaction.amount}</p>
                        <p>
                          {transaction.payment_status === "success" ? (
                            <CustomButton
                              tailwindClasses="bg-green-500 h-4 text-xs flex justify-center items-center text-white px-2 py-1 rounded"
                              label="Paid"
                              onClick={() => {}}
                            />
                          ) : (
                            <CustomButton
                              tailwindClasses="bg-orange-500 text-white px-2 py-1 rounded text-xs"
                              label="Pending"
                              onClick={() => {}}
                            />
                          )}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Tenant Details Box */}
          {agreementTenants.length > 0 && (
            <div>
              <p className="text-xl font-semibold mb-4">Tenant Details</p>
              <div className="rounded-lg bg-white p-10 flex flex-col gap-4 border">
                {/* Primary Tenant Display */}
                <div className="flex items-center gap-4">
                  {renderTenantAvatar(agreementTenants[0])}
                  <div className="flex-1">
                    {renderTenantInfo(agreementTenants[0])}
                    {agreementTenants.length > 1 && (
                      <button
                        onClick={() => setShowAllTenants(!showAllTenants)}
                        className="text-blue-500 hover:text-blue-700 text-sm mt-2"
                      >
                        {showAllTenants
                          ? "Show less"
                          : `+ ${agreementTenants.length - 1} more`}
                      </button>
                    )}
                    <div className="mt-2">
                      <WhatsAppComponent
                        label={"Remind"}
                        selectedTenant={agreementTenants[0]}
                      />
                    </div>
                  </div>
                </div>

                {/* Additional Tenants (collapsible) */}
                {showAllTenants && agreementTenants.length > 1 && (
                  <div className="border-t pt-4 mt-4">
                    <p className="text-sm font-semibold text-gray-600 mb-3">
                      Other Tenants
                    </p>
                    <div className="space-y-3">
                      {agreementTenants.slice(1).map((tenant) => (
                        <div
                          key={tenant.entity_id}
                          className="flex items-center gap-3 p-2 border rounded-lg"
                        >
                          {renderTenantAvatar(tenant, "h-12 w-12")}
                          <div className="flex-1">
                            {renderTenantInfo(tenant)}
                          </div>
                          <div className="flex gap-2">
                            <button
                              onClick={() =>
                                window.open(`tel:${tenant.mobile}`)
                              }
                              className="text-xl"
                            >
                              📞
                            </button>
                            <button
                              onClick={() => setSelectedTenantForModal(tenant)}
                              className="text-blue-600 hover:text-blue-800 text-sm font-semibold"
                            >
                              Details
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Action Buttons */}
                <div className="flex gap-2 mt-4">
                  <button
                    onClick={() =>
                      window.open(`tel:${agreementTenants[0].mobile}`)
                    }
                    className="flex-1 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 flex items-center justify-center gap-2"
                  >
                    📞 Call
                  </button>
                  <CustomButton
                    tailwindClasses="flex-1 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    label="See Details"
                    onClick={() =>
                      setSelectedTenantForModal(agreementTenants[0])
                    }
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Full Width Unit Details Section */}
      <div className="p-4">
        <p className="text-xl font-semibold mb-4">Unit Specifications</p>
        <div className="bg-white rounded-lg shadow-md p-10 border">
          <div className="flex justify-between">
            <div className="w-1/2 flex flex-col gap-4">
              <div className="flex flex-col">
                <p className="font-medium text-lg">{unitName}</p>
                <p className="text-gray-600">
                  {getUnitDetail("address", "N/A")}
                </p>
              </div>
              <div className="flex justify-between items-center">
                <div className="flex flex-col">
                  <p className="text-sm text-gray-500">Flat Area</p>
                  <p className="font-medium">
                    {getUnitDetail("unit_area", "N/A")} sqft
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className="text-sm text-gray-500">BHK</p>
                  <p className="font-medium">{getUnitDetail("bhk", "N/A")}</p>
                </div>
                <div className="flex flex-col">
                  <p className="text-sm text-gray-500">Furnishing</p>
                  <p className="font-medium">
                    {getUnitDetail("furnishing_status", "N/A")}
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="flex flex-col flex-1">
                  <p className="text-sm text-gray-500">Balcony</p>
                  <p className="font-medium">
                    {getUnitDetail("no_of_balcony", "N/A")}
                  </p>
                </div>
                <div className="flex flex-col flex-1">
                  <p className="text-sm text-gray-500">Bathroom</p>
                  <p className="font-medium">
                    {getUnitDetail("no_of_bathrooms", "N/A")}
                  </p>
                </div>
                <div className="flex-1"></div>
              </div>
            </div>
            <CustomButton
              tailwindClasses="bg-blue-500 text-white px-4 py-2 rounded h-fit hover:bg-blue-600"
              label="Edit"
              onClick={() => setIsModalOpen(true)}
            />
          </div>
          {amenitiesList.length > 0 && amenitiesList[0].trim() !== "" && (
            <div className="mt-6 border-t pt-4">
              <p className="font-semibold mb-2">Amenities</p>
              <div className="flex flex-wrap gap-4">
                {amenitiesList.map((amenity, index) => {
                  const { icon, name } = mapAmenitiesToIcons(amenity);
                  return <Facility key={index} name={name} icon={icon} />;
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      {isModalOpen && (
        <CustomModalEditUnit
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          unitDetails={unitDetails}
          buildings={buildings}
          onUpdate={handleUpdateSuccess}
        />
      )}
      {editAgreementModal && agreement && (
        <EditAgreementModal
          key={agreement.entity_id}
          isOpen={editAgreementModal}
          onClose={() => setEditAgreementModal(false)}
          agreementData={agreementDetails}
          onSave={handleAgreementUpdate}
          jwt={jwt}
        />
      )}
      {selectedTenantForModal && (
        <TenantDetailsModal
          isOpen={!!selectedTenantForModal}
          onClose={() => setSelectedTenantForModal(null)}
          unitDetails={unitDetails}
          selectedTenant={selectedTenantForModal}
          allAgreementTenants={agreementTenants}
          jwt={jwt}
        />
      )}
    </div>
  );
}

export default UnitDetails;
